import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/yellow-success-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-394e75e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form_wrapper"
}
const _hoisted_2 = { class: "form_wrapper_content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "logo-description default-text" }, " Time to check your emails. Please enter the code we have just sent to you. ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "error_msg"
}
const _hoisted_5 = { class: "card-part" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "common-title" }, "Already have an account", -1))
const _hoisted_7 = { class: "benefit_wrapper llg:!tw-mb-[20px]" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Take a look at all the amazing benefits iknowa offers", -1))
const _hoisted_10 = {
  key: 1,
  class: "success_wrapper"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "open-logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("h3", null, "Success!")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Your email has been verified successfully."),
  /*#__PURE__*/_createElementVNode("p", null, "Please login.")
], -1))
const _hoisted_13 = { class: "card-part tw-mb-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "common-title" }, "Already have an account", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_AuthIknowaInfoMobileModal = _resolveComponent("AuthIknowaInfoMobileModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.verified === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("p", null, [
              _createTextVNode(" iknowa has just sent a code validation email to "),
              _createElementVNode("strong", null, _toDisplayString($setup.userEmail), 1)
            ]),
            _createElementVNode("label", {
              class: "yellow-text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.resendEmail()))
            }, [
              _createTextVNode("Resend email"),
              _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
            ])
          ]),
          _createVNode(_component_v_form, {
            key: "",
            class: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_otp_input, {
                modelValue: $setup.otp,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.otp) = $event)),
                length: "4",
                variant: "solo-filled",
                class: "",
                "bg-color": "rgba(12, 15, 74, 0.0509803922)"
              }, null, 8, ["modelValue"]),
              ($setup.emailErrorMessage)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.emailErrorMessage), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                disabled: $setup.otp.length < 4,
                class: "button button-orange",
                size: "large",
                rounded: "lg",
                block: "",
                onClick: $setup.redirectToSuccess
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" verify email & continue ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("label", {
              class: "yellow-text",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.returnToLogin && $setup.returnToLogin(...args)))
            }, [
              _createTextVNode(" Log In"),
              _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h6", null, [
                _createVNode(_component_v_icon, { icon: "mdi-star" }),
                _createTextVNode("iknowa Benefits")
              ])
            ]),
            _hoisted_9,
            _createElementVNode("label", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.openOverview && $setup.openOverview(...args))),
              class: "yellow-text"
            }, [
              _createTextVNode("Open iknowa Overview "),
              _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createVNode(_component_v_btn, {
            class: "button button-orange",
            size: "large",
            block: "",
            onClick: $setup.returnToLogin
          }, {
            default: _withCtx(() => [
              _createTextVNode(" continue ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("label", {
              class: "yellow-text",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.returnToLogin && $setup.returnToLogin(...args)))
            }, [
              _createTextVNode(" Log In"),
              _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
            ])
          ])
        ])),
    ($setup.isShowAuthIknowaInfoMobile)
      ? (_openBlock(), _createBlock(_component_AuthIknowaInfoMobileModal, {
          key: 2,
          onOnCloseButtonClick: $setup.onCloseButtonClick
        }, null, 8, ["onOnCloseButtonClick"]))
      : _createCommentVNode("", true)
  ], 64))
}